import { Suspense } from "react";
import { Layout } from "antd";
import SiteHeader from "../components/customization/header";
import Can from "../services/permisions/Can";

const { Content } = Layout;

/* Main Layout */
const UICustomizationLayout = ({ children }) => (
	<Layout>
		<Layout>
			<SiteHeader />
			<Layout>
				<Content>{children}</Content>
			</Layout>
		</Layout>
	</Layout>
);

/*
  Private route wrapper
 */

export const UICustomizationLayoutRoute = ({ component: Component, permissions, ...rest }) => (
	<Can I={permissions.type} a={permissions.name} withRedirect>
		<UICustomizationLayout>
			<Suspense fallback={null}>
				<Component {...rest} />
			</Suspense>
		</UICustomizationLayout>
	</Can>
);
